module.exports = __webpack_public_path__ + "img/Meer4.c0dd15b5.jpg";